"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect, useState } from "react";
import { ApiWave } from "@/generated/models/ApiWave";
import { ApiWavesOverviewType } from "@/generated/models/ApiWavesOverviewType";
import WaveItem from "./WaveItem";
import { AuthContext } from "@/components/auth/Auth";
import { WavesOverviewParams } from "@/types/waves.types";
import { useInfiniteQuery } from "@tanstack/react-query";
import { commonApiFetch } from "@/services/api/common-api";
import CircleLoader, { CircleLoaderSize } from "@/components/distribution-plan-tool/common/CircleLoader";
import CommonIntersectionElement from "@/components/utils/CommonIntersectionElement";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
const LABELS: Record<ApiWavesOverviewType, string> = {
  [ApiWavesOverviewType.Latest]: "Latest",
  [ApiWavesOverviewType.MostSubscribed]: "Most Followed",
  [ApiWavesOverviewType.HighLevelAuthor]: "High Level Authors",
  [ApiWavesOverviewType.AuthorYouHaveRepped]: "Waves from Authors You Have Repped",
  [ApiWavesOverviewType.MostDropped]: "Most Dropped",
  [ApiWavesOverviewType.MostDroppedByYou]: "Most Dropped by You",
  [ApiWavesOverviewType.RecentlyDroppedTo]: "Recently Dropped",
  [ApiWavesOverviewType.RecentlyDroppedToByYou]: "Recently Dropped by You"
};
const SHOW_ALL_REQUEST_SIZE = 12;
const NORMAL_REQUEST_SIZE = 3;
export default function WavesListWrapper(t0) {
  const $ = _c(88);
  const {
    overviewType,
    showAllType,
    setShowAllType
  } = t0;
  const {
    connectedProfile,
    activeProfileProxy
  } = useContext(AuthContext);
  const isShowAll = showAllType === overviewType;
  let t1;
  if ($[0] !== activeProfileProxy || $[1] !== connectedProfile?.handle) {
    t1 = () => !connectedProfile?.handle || !!activeProfileProxy;
    $[0] = activeProfileProxy;
    $[1] = connectedProfile?.handle;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const getUsePublicWaves = t1;
  const [usePublicWaves, setUsePublicWaves] = useState(getUsePublicWaves());
  let t2;
  if ($[3] !== getUsePublicWaves) {
    t2 = () => setUsePublicWaves(getUsePublicWaves());
    $[3] = getUsePublicWaves;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== activeProfileProxy || $[6] !== connectedProfile) {
    t3 = [connectedProfile, activeProfileProxy];
    $[5] = activeProfileProxy;
    $[6] = connectedProfile;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  if ($[8] !== isShowAll || $[9] !== overviewType) {
    t4 = () => ({
      limit: isShowAll ? SHOW_ALL_REQUEST_SIZE : NORMAL_REQUEST_SIZE,
      type: overviewType
    });
    $[8] = isShowAll;
    $[9] = overviewType;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const getParams = t4;
  let t5;
  if ($[11] !== getParams) {
    t5 = getParams();
    $[11] = getParams;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const [params, setParams] = useState(t5);
  let t6;
  if ($[13] !== getParams) {
    t6 = () => setParams(getParams());
    $[13] = getParams;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== isShowAll || $[16] !== overviewType) {
    t7 = [overviewType, isShowAll];
    $[15] = isShowAll;
    $[16] = overviewType;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  useEffect(t6, t7);
  let t8;
  let t9;
  if ($[18] !== params) {
    t8 = [QueryKey.WAVES_OVERVIEW, params];
    t9 = async t10 => {
      const {
        pageParam
      } = t10;
      const queryParams = {
        limit: `${params.limit}`,
        offset: `${pageParam}`,
        type: params.type
      };
      return await commonApiFetch({
        endpoint: "waves-overview",
        params: queryParams
      });
    };
    $[18] = params;
    $[19] = t8;
    $[20] = t9;
  } else {
    t8 = $[19];
    t9 = $[20];
  }
  const t10 = !usePublicWaves;
  let t11;
  if ($[21] !== t10 || $[22] !== t8 || $[23] !== t9) {
    t11 = {
      queryKey: t8,
      queryFn: t9,
      initialPageParam: 0,
      getNextPageParam: _temp,
      enabled: t10
    };
    $[21] = t10;
    $[22] = t8;
    $[23] = t9;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  const {
    data: wavesAuth,
    fetchNextPage: fetchNextPageAuth,
    hasNextPage: hasNextPageAuth,
    isFetching: isFetchingAuth,
    isFetchingNextPage: isFetchingNextPageAuth,
    status: statusAuth
  } = useInfiniteQuery(t11);
  let t12;
  let t13;
  if ($[25] !== params) {
    t12 = [QueryKey.WAVES_OVERVIEW_PUBLIC, params];
    t13 = async t14 => {
      const {
        pageParam: pageParam_0
      } = t14;
      const queryParams_0 = {
        limit: `${params.limit}`,
        offset: `${pageParam_0}`,
        type: params.type
      };
      return await commonApiFetch({
        endpoint: "public/waves-overview",
        params: queryParams_0
      });
    };
    $[25] = params;
    $[26] = t12;
    $[27] = t13;
  } else {
    t12 = $[26];
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t12 || $[29] !== t13 || $[30] !== usePublicWaves) {
    t14 = {
      queryKey: t12,
      queryFn: t13,
      initialPageParam: 0,
      getNextPageParam: _temp2,
      enabled: usePublicWaves
    };
    $[28] = t12;
    $[29] = t13;
    $[30] = usePublicWaves;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  const {
    data: wavesPublic,
    fetchNextPage: fetchNextPagePublic,
    hasNextPage: hasNextPagePublic,
    isFetching: isFetchingPublic,
    isFetchingNextPage: isFetchingNextPagePublic,
    status: statusPublic
  } = useInfiniteQuery(t14);
  let t15;
  if ($[32] !== usePublicWaves || $[33] !== wavesAuth?.pages || $[34] !== wavesPublic?.pages) {
    t15 = () => {
      if (usePublicWaves) {
        return wavesPublic?.pages.flat() ?? [];
      }
      return wavesAuth?.pages.flat() ?? [];
    };
    $[32] = usePublicWaves;
    $[33] = wavesAuth?.pages;
    $[34] = wavesPublic?.pages;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  const getWaves = t15;
  let t16;
  if ($[36] !== getWaves) {
    t16 = getWaves();
    $[36] = getWaves;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  const [waves, setWaves] = useState(t16);
  let t17;
  if ($[38] !== getWaves) {
    t17 = () => setWaves(getWaves());
    $[38] = getWaves;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== usePublicWaves || $[41] !== wavesAuth || $[42] !== wavesPublic) {
    t18 = [wavesAuth, wavesPublic, usePublicWaves];
    $[40] = usePublicWaves;
    $[41] = wavesAuth;
    $[42] = wavesPublic;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  useEffect(t17, t18);
  let t19;
  if ($[44] !== overviewType || $[45] !== setShowAllType || $[46] !== showAllType) {
    t19 = () => {
      if (showAllType === overviewType) {
        setShowAllType(null);
        return;
      }
      setShowAllType(overviewType);
    };
    $[44] = overviewType;
    $[45] = setShowAllType;
    $[46] = showAllType;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  const onShowAll = t19;
  let t20;
  if ($[48] !== fetchNextPageAuth || $[49] !== fetchNextPagePublic || $[50] !== hasNextPageAuth || $[51] !== hasNextPagePublic || $[52] !== isFetchingAuth || $[53] !== isFetchingNextPageAuth || $[54] !== isFetchingNextPagePublic || $[55] !== isFetchingPublic || $[56] !== statusAuth || $[57] !== statusPublic || $[58] !== usePublicWaves || $[59] !== waves.length) {
    t20 = state => {
      if (waves.length < SHOW_ALL_REQUEST_SIZE) {
        return;
      }
      if (!state) {
        return;
      }
      if (usePublicWaves) {
        if (statusPublic === "pending") {
          return;
        }
        if (isFetchingPublic) {
          return;
        }
        if (isFetchingNextPagePublic) {
          return;
        }
        if (!hasNextPagePublic) {
          return;
        }
        fetchNextPagePublic();
        return;
      }
      if (statusAuth === "pending") {
        return;
      }
      if (isFetchingAuth) {
        return;
      }
      if (isFetchingNextPageAuth) {
        return;
      }
      if (!hasNextPageAuth) {
        return;
      }
      fetchNextPageAuth();
    };
    $[48] = fetchNextPageAuth;
    $[49] = fetchNextPagePublic;
    $[50] = hasNextPageAuth;
    $[51] = hasNextPagePublic;
    $[52] = isFetchingAuth;
    $[53] = isFetchingNextPageAuth;
    $[54] = isFetchingNextPagePublic;
    $[55] = isFetchingPublic;
    $[56] = statusAuth;
    $[57] = statusPublic;
    $[58] = usePublicWaves;
    $[59] = waves.length;
    $[60] = t20;
  } else {
    t20 = $[60];
  }
  const onBottomIntersection = t20;
  if (!waves.length) {
    return null;
  }
  const t21 = LABELS[overviewType];
  let t22;
  if ($[61] !== t21) {
    t22 = <span className="tw-text-xl tw-font-semibold tw-text-iron-50">{t21}</span>;
    $[61] = t21;
    $[62] = t22;
  } else {
    t22 = $[62];
  }
  let t23;
  if ($[63] !== isShowAll || $[64] !== onShowAll || $[65] !== waves.length) {
    t23 = waves.length >= NORMAL_REQUEST_SIZE && <button onClick={onShowAll} className={`tw-group tw-whitespace-nowrap tw-bg-transparent tw-border-none tw-text-iron-400 hover:tw-text-iron-50 tw-text-sm tw-font-semibold tw-cursor-pointer tw-transition tw-duration-300 tw-ease-out tw-flex tw-items-center ${!isShowAll ? "hover:tw-translate-x-[-8px] -tw-mr-4" : ""}`}><span className={`${!isShowAll ? "group-hover:tw-translate-x-[-4px] tw-transition-transform tw-duration-300 tw-ease-out" : ""}`}>{isShowAll ? "Show less" : "Show all"}</span>{!isShowAll && <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="tw-w-4 tw-h-4 tw-ml-1 tw-opacity-0 group-hover:tw-opacity-100 tw-transition-opacity tw-duration-300 tw-ease-out"><path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" /></svg>}</button>;
    $[63] = isShowAll;
    $[64] = onShowAll;
    $[65] = waves.length;
    $[66] = t23;
  } else {
    t23 = $[66];
  }
  let t24;
  if ($[67] !== t22 || $[68] !== t23) {
    t24 = <div className="tw-inline-flex tw-w-full tw-items-center tw-justify-between">{t22}{t23}</div>;
    $[67] = t22;
    $[68] = t23;
    $[69] = t24;
  } else {
    t24 = $[69];
  }
  let t25;
  if ($[70] !== overviewType || $[71] !== waves) {
    let t26;
    if ($[73] !== overviewType) {
      t26 = wave => <WaveItem key={`${overviewType}-${wave.id}`} wave={wave} />;
      $[73] = overviewType;
      $[74] = t26;
    } else {
      t26 = $[74];
    }
    t25 = waves.map(t26);
    $[70] = overviewType;
    $[71] = waves;
    $[72] = t25;
  } else {
    t25 = $[72];
  }
  let t26;
  if ($[75] !== t25) {
    t26 = <div className="tw-mt-3 tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-4 lg:tw-gap-5">{t25}</div>;
    $[75] = t25;
    $[76] = t26;
  } else {
    t26 = $[76];
  }
  let t27;
  if ($[77] !== isFetchingAuth || $[78] !== isFetchingPublic || $[79] !== isShowAll || $[80] !== onBottomIntersection) {
    t27 = isShowAll && <>{(isFetchingAuth || isFetchingPublic) && <div className="tw-w-full tw-text-center tw-mt-8"><CircleLoader size={CircleLoaderSize.XXLARGE} /></div>}<CommonIntersectionElement onIntersection={onBottomIntersection} /></>;
    $[77] = isFetchingAuth;
    $[78] = isFetchingPublic;
    $[79] = isShowAll;
    $[80] = onBottomIntersection;
    $[81] = t27;
  } else {
    t27 = $[81];
  }
  let t28;
  if ($[82] !== t26 || $[83] !== t27) {
    t28 = <div className="tw-overflow-hidden">{t26}{t27}</div>;
    $[82] = t26;
    $[83] = t27;
    $[84] = t28;
  } else {
    t28 = $[84];
  }
  let t29;
  if ($[85] !== t24 || $[86] !== t28) {
    t29 = <div>{t24}{t28}</div>;
    $[85] = t24;
    $[86] = t28;
    $[87] = t29;
  } else {
    t29 = $[87];
  }
  return t29;
}
function _temp2(__0, allPages_0) {
  return allPages_0.flat().length;
}
function _temp(_, allPages) {
  return allPages.flat().length;
}